import { injectReducer } from "store/reducers";
import Levels from "MultiLevelNodeEditor/routes/Levels";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "atl",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Teacher/modules/TeacherModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/modules/AdministratorModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "SubjectsSetup/modules/SubjectsModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const teacherReducer = importedModule2.default;
          const administratorReducer = importedModule3.default;
          const subjectSetupReducer = importedModule4.default;
          injectReducer(store, {
            key: "subjectsSetup",
            reducer: subjectSetupReducer,
          });
          injectReducer(store, {
            key: "administrator",
            reducer: administratorReducer,
          });
          injectReducer(store, {
            key: "teacher",
            reducer: teacherReducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Levels(store)],
});
